import { FiCircle } from 'react-icons/fi';
import { Box, Radio } from '@mui/material';
import { BsRecordCircle } from 'react-icons/bs';

type Props = {
  selectedValue: string;
  data: object[];
  style?: any;
  setSelectedValue: (e: string) => void;
  disabled?: boolean;
};

export default function RadioComponent({
  data,
  selectedValue,
  setSelectedValue,
  disabled,
  style,
}: Props) {
  const handleClick = (i: any) => {
    if (disabled) {
      return;
    }
    setSelectedValue(i);
  };

  return (
    <Box
      display='flex'
      alignItems='flex-start'
      sx={style}
      flexDirection='column'
      flexWrap='wrap'
      gap='15px'>
      {data.map((i: any, index: number) => (
        <Box key={index} onClick={() => handleClick(i.value)} sx={{ cursor: 'pointer' }}>
          <Radio
            disableRipple
            value='complicated'
            name='radio-buttons'
            disabled={disabled}
            icon={<FiCircle size={20} />}
            checked={selectedValue === i.value}
            onChange={() => handleClick(i.value)}
            checkedIcon={<BsRecordCircle size={20} />}
            inputProps={{ 'aria-label': 'complicated' }}
          />
          {i.title}
        </Box>
      ))}
    </Box>
  );
}
